import { useBooleanFlagValue } from "@openfeature/react-sdk";
import { FeatureFlagVariables } from "../../../constants/featureFlag";

export function useIsIncomeAvailable(): boolean {
  const defaultValue = false;

  const isIncomeAvailable = useBooleanFlagValue(FeatureFlagVariables.isIncomeAvailable, defaultValue);

  return isIncomeAvailable;
}
